import { type Shipment } from 'shipments/domain/Shipment'

import { type Participant } from '../domain/Chat'

export function formatChatSubject({
  quoteId,
  shipmentId,
  carrierName,
}: {
  quoteId?: string
  shipmentId: string
  carrierName: string
}): string {
  const ids = [quoteId, shipmentId].filter(Boolean).join(' / ')
  const prefix = ids ? `Shipment ${ids} • ` : ''
  return `${prefix}${carrierName}`
}

/**
 * While the chat is loading, we don't have the participants yet, so we use the shipment data to create the subtitle.
 */
export function formatChatSubtitle(shipment: Shipment, participants?: Pick<Participant, 'name'>[]) {
  if (participants && participants.length > 0) {
    return participants.map(({ name }) => name).join(', ')
  }

  return `${shipment.carrier.name}, ${shipment.shipper!.companyName}`
}
